import service from '@/utils/server';
let model = '/fm/userType/'
export const queryList = data => {
    return service({
        url: model+'pageInfo',
        method: 'post',
        data
    })
};

export const updateObject = data => {
    return service({
        url: model+'edit',
        method: 'post',
        data
    })
};

//修改初始化
export const initUserType = data => {
  return service({
    url: model+'detail/'+ data.id,
    method: 'post',
    data
  })
};






// WEBPACK FOOTER //
// ./src/page/auth/userType/api/index.js